import * as React from 'react';
import { FlexCol, FlexRow } from './Flexbox/Flexbox';
import { StyledFunction } from 'styled-components';
import * as s from 'styled-components';

const styled = s.default;

export interface Props {
  children: any;
  title: string;
  showTitleDesktop?: boolean;
  childPadding?: boolean;
  titleStyle?: React.CSSProperties;
  padding?: string;
  titleArrowSrc?: string;
  className?: string;
}

export interface State {
  active: boolean;
}

export class MobileDropdownToggle extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
  }

  public toggleActive = () => {
    this.setState({ active: !this.state.active });
  };

  public getTitle = title => {
    return (
      <ListTitle className={this.props.className ? this.props.className : ''}>
        {' '}
        {title}{' '}
      </ListTitle>
    );
  };

  public render() {
    const { children, title, childPadding, padding } = this.props;
    return (
      <Placeholder>
        <div className={'hideDesktop'}>
          <MobileDropdownToggleComponent>
            <Title
              style={this.props.titleStyle}
              onClick={this.toggleActive}
              padding={padding}
            >
              {this.getTitle(title)}
              <Arrow
                active={this.state.active}
                src={
                  this.props.titleArrowSrc || '/images/dropdown-arrow-green.svg'
                }
              />
            </Title>
            <MobileDropdownToggleContent
              style={{
                opacity: this.state.active === true ? 1 : 0,
                paddingLeft: childPadding ? '20px' : '0',
              }}
            >
              {this.state.active && children}
            </MobileDropdownToggleContent>
          </MobileDropdownToggleComponent>
        </div>
        <div className={'hideMobile'}>
          {this.props.showTitleDesktop && this.getTitle(title)}
          {children}
        </div>
      </Placeholder>
    );
  }
}

export const Placeholder: any = styled.div`
  flex-basis: 25%;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

  .hideMobile {
    @media only screen and (max-width: ${({ theme }) =>
        theme.sizes.m || '900'}px) {
      display: none;
    }
  }

  .hideDesktop {
    @media screen and (min-width: ${({ theme }) =>
        theme.sizes.m + 1 || '901'}px) {
      display: none;
    }
  }
`;

const MobileDropdownToggleContent = styled.div`
  transition: all 0.3s ease;
`;

const ListTitle = styled.h2`
  color: ${({ theme }) =>
    theme.footerDropdownTitle.titleColor || theme.secondaryFontColor};
  font-size: ${({ theme }) => theme.fontSizeL};
  font-family: ${({ theme }) => theme.fonts.secondaryFont};
  font-weight: 400;
  line-height: ${({ theme }) => theme.footerDropdownTitle.lineHeight};
  margin: 0;

  ${({ theme }) => theme.media.s`
    font-size: ${theme.footerDropdownTitle.titleSizeMobile || theme.fontSizeM};
  `};
`;

const MobileDropdownToggleComponent = styled(FlexCol)`
  cursor: pointer;
  background: ${({ theme }) => theme.primary};
`;

interface TitleProps {
  padding?: string;
  style?: React.CSSProperties;
  onClick: any;
}
const TitleStyled: StyledFunction<TitleProps> = styled(FlexRow);
const Title = TitleStyled`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;

  ${(props: TitleProps) => {
    if (props.padding) {
      return `padding: ${props.padding}`;
    }
    return;
  }}
`;

const Arrow = styled.img`
  width: ${({ theme }) => theme.footerDropdownTitle.arrow.width || '15px'};
  height: ${({ theme }) => theme.footerDropdownTitle.arrow.width || '15px'};
  vertical-align: middle;
  transition: all 0.2s;
  position: relative;

  ${(props: { active: boolean }) => {
    if (props.active) {
      return `
        transform: rotate(-180deg);
      `;
    }
    return;
  }};
`;
